import { render, staticRenderFns } from "./WebReviewItem.vue?vue&type=template&id=398f7e00&scoped=true&"
import script from "./WebReviewItem.vue?vue&type=script&lang=js&"
export * from "./WebReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./WebReviewItem.vue?vue&type=style&index=0&id=398f7e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f7e00",
  null
  
)

export default component.exports